import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import * as XLSX from "xlsx";
import { Box, Typography, Button } from "@mui/material";

export default function InnovateX() {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch applicants data
  useEffect(() => {
    const fetchApplicants = async () => {
      try {
        const response = await axios.get(
          "https://puneexpobackend.tdtlworld.com/innovate/all_applicants/"
        );
        setApplicants(response.data.msg);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching applicants data:", error);
        setLoading(false);
      }
    };
    fetchApplicants();
  }, []);

  // Define columns
  const columns = [
    // { field: "id", headerName: "ID", width: 90 },
    { field: "full_name", headerName: "Full Name", width: 200 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "phone_number", headerName: "Phone Number", width: 150 },
    { field: "address", headerName: "Address", width: 300 },
    { field: "city", headerName: "City", width: 150 },
    { field: "state", headerName: "State", width: 150 },
    { field: "postal_code", headerName: "Postal Code", width: 120 },
    { field: "country", headerName: "Country", width: 150 },
    { field: "institution", headerName: "Institution", width: 250 },
    { field: "field_of_study", headerName: "Field of Study", width: 200 },
    { field: "graduation_year", headerName: "Graduation Year", width: 150 },
    { field: "gender", headerName: "Gender", width: 100 },
    { field: "graduation_degree", headerName: "Graduation Degree", width: 200 },
    {
      field: "post_graduation_degree",
      headerName: "Post-Graduation Degree",
      width: 200,
    },
    {
      field: "skills",
      headerName: "Skills",
      width: 300,
    },
    {
      field: "resume_upload",
      headerName: "Resume",
      width: 300,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          View Resume
        </a>
      ),
    },
  ];

  // Function to download data as Excel
  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(applicants); // Convert data to worksheet
    const workbook = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applicants"); // Append worksheet to workbook
    XLSX.writeFile(workbook, "InnovateX_Applicants.xlsx"); // Save workbook
  };

  return (
    <Box
      sx={{
        height: "85vh",
        width: "95%",
        margin: "70px auto",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          textAlign: "start",
          marginBottom: "20px",
          marginLeft:"0px",
          fontWeight: "bold",
          color: "#1976d2",
        }}
      >
        InnovateX Applicants
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={downloadExcel}
        sx={{
          marginBottom: "20px",
          marginLeft: "auto",
          marginRight: "auto",
          display: "block",
        }}
      >
        Download as Excel
      </Button>

      <DataGrid
  rows={applicants}
  columns={columns}
  pageSize={10}
  rowsPerPageOptions={[5, 10, 20]}
  loading={loading}
  components={{ Toolbar: GridToolbar }}
  getRowId={(row) => row.id}
//   checkboxSelection
  disableSelectionOnClick
  sx={{
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    padding: "3px",
    "& .MuiDataGrid-toolbarContainer": {
      padding: "10px",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#f9f9f9", // Light background
      color: "#000000",          // Set text color to black
      fontSize: "16px",
    },
    "& .MuiDataGrid-cell": {
      fontSize: "14px",
      color: "#333",
    },
  }}
/>

    </Box>
  );
}
